import BaseURL from "./baseURL";

const homeAPI = {
	HOME_URL: `${BaseURL.LOCAL_BASE_URL}/home/user-rounds`,
};

export default homeAPI;
